import { type CampaignSource } from '../../../types/campaign.types';
import { useCampaignPrizesQueryById } from '../useCampaignsQuery';

export interface PrizePopCardLiveData {
  /** Remaining prizes for the card's "Prizes" item. */
  prizesLeft: number;
}

/**
 * Prize Pop card live data — remaining prizes, polled while the card is active.
 * Self-gates: `useCampaignPrizesQueryById` only fetches when the resolved config
 * has a `prizes` sub-fetch (i.e. for prize pop campaigns).
 */
export const usePrizePopCardLiveData = (
  campaign: CampaignSource | null | undefined,
  isActive: boolean,
): PrizePopCardLiveData => {
  const prizesQuery = useCampaignPrizesQueryById(campaign, isActive);
  return { prizesLeft: prizesQuery.data?.totalRemaining ?? 0 };
};
